// extracted by mini-css-extract-plugin
module.exports = {"head":"ModalHead_head__3dGnf","cssVarsMain":"ModalHead_cssVarsMain__3dLJv","cssVarsSub":"ModalHead_cssVarsSub__2g5K2"};